import { authFetch } from "./authProvider";

const SERVICE_URL = "";
export const addSignature = async (signatureData) => {
  let url =
    SERVICE_URL +
    "/wash-inventory-service/v2/organizations/1/wash-inventories/approve";
  return await authFetch("post", url, signatureData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
};
